import { goto } from '$app/navigation';
import { attachClaimedReflections } from '$features/clara';
import { fetchMyProfileOrNull } from '$features/onboarding/api/client';
import { resolvePostAuthDestination } from '$features/onboarding/services/post-auth-router';

export async function navigateAfterAuth(): Promise<void> {
  // Someone may have reflected as a guest and left their email days ago. Sign-up is where
  // Cognito proves that address, so this is the first moment we are entitled to hand the
  // reflection over. Best effort: never let it block the person getting into the app.
  try {
    await attachClaimedReflections();
  } catch (error) {
    console.error('Could not attach previously claimed reflections', error);
  }

  const profile = await fetchMyProfileOrNull();
  await goto(resolvePostAuthDestination(profile));
}
